import React from 'react';
import Icon from '../../../components/AppIcon';


const ConversationList = ({ conversations, selectedId, onSelect, searchQuery, onSearchChange }) => {
  const formatTime = (date) => {
    const dateObj = new Date(date);
    const now = new Date();
    const diff = now - dateObj;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (hours < 1) return 'Just now';
    if (hours < 24) return `${hours}h ago`;
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days}d ago`;
    return dateObj?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const getStageColor = (stage) => {
    const colors = {
      'Initial Connection': 'bg-blue-100 text-blue-700',
      'In Conversation': 'bg-purple-100 text-purple-700',
      'Reveal Pending': 'bg-amber-100 text-amber-700',
      'Reveal Approved': 'bg-emerald-100 text-emerald-700',
      'Meeting Scheduled': 'bg-cyan-100 text-cyan-700'
    };
    return colors?.[stage] || 'bg-gray-100 text-gray-700';
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] h-full flex flex-col">
      {/* Search Header */}
      <div className="p-4 border-b border-[#E5E7EB]">
        <div className="relative">
          <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6B7280]" />
          <input
            type="text"
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 border border-[#E5E7EB] rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#5B2DFF] focus:border-transparent"
          />
        </div>
      </div>

      {/* Conversations List */}
      <div className="flex-1 overflow-y-auto">
        {conversations?.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="Search" size={32} color="#6B7280" className="mx-auto mb-3" />
            <p className="text-sm text-[#6B7280]">No conversations found</p>
          </div>
        ) : (
          conversations?.map((conversation) => (
            <button
              key={conversation?.id}
              onClick={() => onSelect(conversation)}
              className={`w-full p-4 border-b border-[#E5E7EB] hover:bg-[#F6F7FB] transition-colors text-left ${
                selectedId === conversation?.id ? 'bg-[#F6F7FB]' : ''
              }`}
            >
              <div className="flex items-start gap-3">
                {/* Avatar with online status */}
                <div className="relative flex-shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center">
                    <Icon name="Briefcase" size={24} color="#FFFFFF" />
                  </div>
                  {conversation?.isOnline && (
                    <div className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-emerald-500 border-2 border-white rounded-full" />
                  )}
                </div>

                {/* Conversation Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <h4 className="text-sm font-semibold text-[#111827] truncate">
                      {conversation?.title}
                    </h4>
                    {conversation?.unreadCount > 0 && (
                      <span className="flex-shrink-0 w-5 h-5 bg-[#5B2DFF] text-white text-xs font-semibold rounded-md flex items-center justify-center">
                        {conversation?.unreadCount}
                      </span>
                    )}
                  </div>
                  
                  <p className="text-xs text-[#6B7280] mb-2 truncate">
                    {conversation?.companyInfo}
                  </p>

                  <p className="text-xs text-[#6B7280] line-clamp-2 mb-2">
                    {conversation?.lastMessage}
                  </p>

                  <div className="flex items-center justify-between gap-2">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getStageColor(conversation?.matchStage)}`}>
                      {conversation?.matchStage}
                    </span>
                    <span className="text-xs text-[#6B7280]">
                      {formatTime(conversation?.lastMessageTime)}
                    </span>
                  </div>
                </div>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationList;